import { useState, useEffect } from "react";
import { memoryStore } from "../utils/storage";

const KEY = "pension_advisor_logo_v1";

export function useLogoStore() {
  const [logo, setLogo] = useState(() => memoryStore.getItem(KEY));

  useEffect(() => {
    const onSync = () => setLogo(memoryStore.getItem(KEY));
    window.addEventListener('pension-data-synced', onSync);
    return () => window.removeEventListener('pension-data-synced', onSync);
  }, []);

  function save(base64) {
    memoryStore.setItem(KEY, base64);
    setLogo(base64);
  }

  function clear() {
    memoryStore.removeItem(KEY);
    setLogo(null);
  }

  return { logo, save, clear };
}
